import { useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";
import { useDispatch } from "react-redux";
import { setNotificationCount } from "../redux/slices/notificationSlice";

const useNotificationCount = (userId) => {

    const dispatch = useDispatch()

    useEffect(() => {
        if (!userId) return;

        const ref = doc(db, "notification_counts", userId);

        const unsubscribe = onSnapshot(ref, (docSnap) => {
            if (docSnap.exists()) {
                const newCount = docSnap.data().count || 0;
                dispatch(setNotificationCount(newCount));
            } else {
                dispatch(setNotificationCount(0));
            }
        });

        return () => unsubscribe();
    }, [userId]);

};

export default useNotificationCount;
